/**
 * PasswordRulesList — Live-Vorschau der BSI-Passwort-Regeln im
 * Fachperson-Signup-Form (UX-Audit Phase 5, extrahiert aus Login.tsx).
 *
 * Hartes Match passiert im Zod-Schema (`schemas/auth.ts`). Diese Liste
 * dient nur der Sichtbarkeit — User sehen waehrend des Tippens,
 * welche Regeln noch fehlen.
 */

import { Check, X } from 'lucide-react';

// BSI-Empfehlung: min. 12 Zeichen, Groß/Klein/Zahl/Sonderzeichen.
export const PASSWORD_RULES = [
  { label: 'Mindestens 12 Zeichen', test: (pw: string) => pw.length >= 12 },
  { label: 'Großbuchstabe (A–Z)', test: (pw: string) => /[A-Z]/.test(pw) },
  { label: 'Kleinbuchstabe (a–z)', test: (pw: string) => /[a-z]/.test(pw) },
  { label: 'Zahl (0–9)', test: (pw: string) => /[0-9]/.test(pw) },
  { label: 'Sonderzeichen (!@#$…)', test: (pw: string) => /[^A-Za-z0-9]/.test(pw) },
] as const;

interface Props {
  password: string;
}

export function PasswordRulesList({ password }: Props) {
  if (!password) return null;
  return (
    <ul className="mt-2 space-y-1">
      {PASSWORD_RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li
            key={rule.label}
            className={`flex items-center gap-1.5 text-xs ${
              ok ? 'text-green-600' : 'text-muted-foreground'
            }`}
          >
            {ok ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />}
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
}
